import type {SharedBulkActionsItemPickerProps} from '@github-ui/item-picker-base/ItemPicker'
import type {IssueTypePickerIssueType} from '@github-ui/item-picker-issue-type'
import {useCallback} from 'react'

import {useUpdateIssueIssueTypeBulkMutation} from './mutations/use-update-issue-issue-type-bulk-mutation'
import {IssueTypePicker, type IssueTypePickerProps} from './IssueTypePicker'

export type BulkIssueIssueTypePickerProps = Omit<IssueTypePickerProps, 'onSelectionChange'> &
  SharedBulkActionsItemPickerProps &
  Parameters<typeof useUpdateIssueIssueTypeBulkMutation>[0]

export function BulkIssueIssueTypePicker({
  onError,
  onCompleted,
  onMutate,
  issuesToActOn,
  activeIssueType,
  ...rest
}: BulkIssueIssueTypePickerProps) {
  const {mutate: bulkUpdateMutate} = useUpdateIssueIssueTypeBulkMutation({onMutate})
  const onSelectionChange = useCallback(
    (selectedIssueType: IssueTypePickerIssueType[]) => {
      const issueTypeId = selectedIssueType.length === 1 ? selectedIssueType[0]?.id : null
      if (!issueTypeId || issueTypeId === activeIssueType?.id) return
      const ids = [...issuesToActOn]
      const input = {ids, issueTypeId, issueType: selectedIssueType[0]}

      bulkUpdateMutate(input, {
        onSuccess: response => onCompleted?.(response.data.updateIssuesBulk.jobId),
        onError,
      })
    },
    [bulkUpdateMutate, issuesToActOn, activeIssueType?.id, onCompleted, onError],
  )

  return <IssueTypePicker onSelectionChange={onSelectionChange} activeIssueType={activeIssueType} {...rest} />
}

try{ BulkIssueIssueTypePicker.displayName ||= 'BulkIssueIssueTypePicker' } catch {}